import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"
import { UserProfileComponent } from "./user-profile.component"
// import { UserProfileOldComponent } from "./user-profile-old/user-profile-old.component"

const userProfileRoutes: Routes = [
    { path: "", component: UserProfileComponent },

    { path: "**", redirectTo: "" },
]

// { path: "old", component: UserProfileOldComponent },

@NgModule({
    imports: [RouterModule.forChild(userProfileRoutes)],
    exports: [RouterModule],
})
export class UserProfileRoutingModule {}
